var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-tooltip',{attrs:{"effect":_vm.isDark ? 'dark':'light',"content":_vm.content,"placement":"top-start"}},[_c('div',[_vm._t("default"),_c('i',{staticClass:"el-icon-question",staticStyle:{"margin":"0 0px"}})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }